import React, { useEffect } from "react";
import { NotificationContainer, NotificationManager, } from "react-notifications";
import "react-notifications/lib/notifications.css";

const Noti = () => {
	// Clear remaining notification messages in task queue on mount
	useEffect(() => {
		NotificationManager.listNotify = [];
	}, []);
	return <NotificationContainer />;
};

Noti.create = ({ type, title = null, msg = "" }) => {
	switch (type) {
		case "s":
			return NotificationManager.success(title, msg);
		case "w":
			return NotificationManager.warning(title, msg);
		case "e":
			return NotificationManager.error(title, msg);
		case "i":
			return NotificationManager.info(msg);
		default:
			NotificationManager.success(title, msg);
	}
};

export default Noti;
